
export { RatingStars } from "/home/runner/work/apollo/apollo/packages/core/ui/src/atoms/rating-stars/rating-stars.tsx"